<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <h3 class="event-title">
              {{ (event.code != "") ? event.code + " - " : "" }} {{ event.name }}
              <CButton
                color="warning"
                size="sm"
                class="home-edit-button"
                style="color: #fff"
                @click="updateModal()"
              >
                <CIcon name="cil-pencil" />
              </CButton>
              <template v-if="event.has_overcapacity">
                <CBadge color="danger">SOBRECUPO</CBadge>
              </template>
            </h3>
            <div class="card-header-actions" style="float:left;">
              <CRow>
                <CCol md="12" style="display:flex;">
                  <div>
                    <template v-if="event.description != ''">
                      <span style="font-size: 12px;">{{ event.description }}</span>
                      <br>
                    </template>
                    <template v-if="event.address != ''">
                      <span style="font-size: 12px;">{{ event.address }}</span>
                      <br>
                    </template>
                    Fecha: <strong>{{ event.date | date }}</strong>
                    <template v-if="event.start_hour != '' || event.end_hour != ''">
                      <span style="font-size: 10px;">
                        - <strong>{{ event.start_hour }}/{{ event.end_hour }}</strong>
                      </span>
                    </template>
                    <br>
                    Dias Restantes: <strong>{{ event.days_left }}</strong>
                    <br>
                    Estado:
                    <template v-if="event.status.code == 'open'">
                      <CBadge color="warning">{{ event.status.name }}</CBadge>
                    </template>
                    <template v-else-if="event.status.code == 'done'">
                      <CBadge color="success">{{ event.status.name }}</CBadge>
                    </template>
                    <template v-else-if="event.status.code == 'canceled'">
                      <CBadge color="danger">{{ event.status.name }}</CBadge>
                    </template>
                    <template v-else>
                      <CBadge color="info">{{ event.status.name }}</CBadge>
                    </template>
                    <br>
                    <template v-if="event.num_tables > 0">
                      N° Mesas: {{ event.num_tables }}
                    </template>
                  </div>
                </CCol>
              </CRow>
            </div>
            <div class="card-header-actions">
              <CRow>
                <CCol md="12">
                  <CRow>
                    <CCol md="12">
                      <CRow>
                        <CCol md="4">
                        </CCol>
                        <CCol xs="12" md="8">
                          <div role="group" class="form-group ">
                            <CSelect :value.sync="eventSelect" :options="eventsOptions" @change="changeEvent" />
                          </div>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol md="4">
                    </CCol>
                    <CCol xs="12" md="8" class="home-actions-wrap">
                      <div class="home-actions-toolbar">
                        <CButtonGroup
                          v-if="showButton('new-guest') || showCommunicationsDropdown || showImportExportDropdown"
                          size="sm"
                          class="home-actions-group mb-2"
                        >
                          <CButton
                            v-if="showButton('new-guest')"
                            color="danger"
                            @click="addGuestModal()"
                          >
                            Nuevo Invitado
                          </CButton>

                          <CDropdown
                            v-if="showCommunicationsDropdown"
                            color="info"
                            size="sm"
                            class="home-actions-dropdown"
                          >
                            <template #toggler-content>
                              Envios
                            </template>

                            <CDropdownItem v-if="showButton('schedule-sends')" href="#" @click="goToEventDetail('scheduled')">
                              Programar envio
                            </CDropdownItem>

                            <CDropdownDivider v-if="showButton('schedule-sends') && showCommunicationItemsDivider" />

                            <CDropdownItem v-if="showButton('send-message')" href="#" @click="sendMasiveMessage()">
                              Enviar Mensaje
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-remember')" href="#" @click="sendMasiveInvitation()">
                              Enviar Recordatorios
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-invitation')" href="#" @click="sendMasiveFirstInvitation()">
                              Enviar Invitaciones
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-save-date')" href="#" @click="sendSaveTheDateMessage()">
                              Save The Date
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-preinvitation')" href="#" @click="sendPreInvitationMessage()">
                              Preinvitacion
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-event-reminder')" href="#" @click="sendEventReminderMessage()">
                              Recordatorio de Evento
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-tables')" href="#" @click="sendTableMessage()">
                              Enviar Mesa
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-masive-tickets-email')" href="#" @click="sendMasiveTickets()">
                              Enviar Tickets
                            </CDropdownItem>
                          </CDropdown>

                          <CDropdown
                            v-if="showImportExportDropdown"
                            color="success"
                            size="sm"
                            class="home-actions-dropdown"
                          >
                            <template #toggler-content>
                              Importar / Exportar
                            </template>

                            <CDropdownItem v-if="showButton('import-guests')" href="#" @click="importModal()">
                              Importar Invitados
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('download-pdf')" href="#" @click="downloadPdf()">
                              Exportar Ficha
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('export-guests')" href="#" @click="downloadExcel()">
                              Exportar Listado Excel
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('send-excel-email')" href="#" @click="sendGuestsExcelByEmail()">
                              Enviar Excel por correo
                            </CDropdownItem>

                            <CDropdownDivider v-if="showButton('export-attendance') || showButton('scanQR')" />

                            <CDropdownItem v-if="showButton('export-attendance')" href="#" @click="downloadExcelAttendance()">
                              Exportar Asistencia
                            </CDropdownItem>

                            <CDropdownItem v-if="showButton('scanQR')" :to="{ name: 'scan-tickets', params: { id: event.id } }">
                              Escanear CODIGOS
                            </CDropdownItem>
                          </CDropdown>
                        </CButtonGroup>

                        <CButtonGroup size="sm" class="home-actions-group-secondary mb-2 ml-md-2">
                          <CButton
                            v-if="showButton('assign-table')"
                            class="crema"
                            @click="assignTable()"
                          >
                            Asignar Mesa
                          </CButton>

                          <CButton
                            color="dark"
                            :to="{ name: 'event-detail', params: { id: event.id } }"
                          >
                            Ver detalle
                          </CButton>
                        </CButtonGroup>
                      </div>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </div>
          </CCardHeader>
          <CCardBody>
            <EventStatsCards :event-id="eventSelect" :refresh-token="dashboardRefreshToken" />

            <CRow class="mb-3">
              <CCol md="12">
                <ConfirmationSummaryChart :event-id="eventSelect" :refresh-token="dashboardRefreshToken" />
              </CCol>
            </CRow>

            <CRow class="mb-3">
              <CCol md="6" class="mb-3 mb-md-0">
                <TableOccupationCard :event-id="eventSelect" :refresh-token="dashboardRefreshToken" />
              </CCol>
              <CCol md="6">
                <NextScheduledDeliveryCard
                  :event-id="eventSelect"
                  :event="event"
                  :refresh-token="dashboardRefreshToken"
                  @edit="goToEventDetail('scheduled')"
                  @changed="refreshDashboardPanels"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6" class="mb-3 mb-md-0">
                <RecentActivityCard :event-id="eventSelect" :refresh-token="dashboardRefreshToken" />
              </CCol>
              <CCol md="6">
                <DeliveryHistoryCard
                  :event-id="eventSelect"
                  :refresh-token="dashboardRefreshToken"
                  @open-history="goToEventDetail('history')"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <GuestModal ref="addGuestModal" @refreshItems="changeEvent"></GuestModal>
          <ImportGuestsModal ref="importModal" @refresh="changeEvent"></ImportGuestsModal>
          <SendMasiveInvitationModal ref="sendMasiveInvitationModal"></SendMasiveInvitationModal>
          <SendMasiveMessageModal ref="sendMasiveMessageModal"></SendMasiveMessageModal>
          <SendSaveTheDateModal ref="sendSaveTheDateModal"></SendSaveTheDateModal>
          <SendTableMessageModal ref="sendTableMessageModal"></SendTableMessageModal>
          <AssignTable ref="assignTableModal" @refreshItems="changeEvent"></AssignTable>
          <SendMasiveTicketsModal ref="sendMasiveTicketsModal"></SendMasiveTicketsModal>
          <SendGuestsExcelModal ref="sendGuestsExcelModal"></SendGuestsExcelModal>
          <EventModal ref="addModal" @update="updateProcess"></EventModal>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>

import EventModal from '@/components/events/EventModal.vue';
import GuestModal from '@/components/events/event/detail/guests/GuestModal.vue';
import ImportGuestsModal from '@/components/events/event/detail/guests/ImportGuestsModal.vue';
import SendMasiveInvitationModal from '@/components/events/event/detail/sendWhatsapp/SendMasiveInvitationModal.vue';
import SendMasiveMessageModal from '@/components/events/event/detail/sendWhatsapp/SendMasiveMessageModal.vue';
import SendTableMessageModal from '@/components/events/event/detail/sendWhatsapp/SendTableMessageModal.vue';
import SendSaveTheDateModal from '@/components/events/event/detail/sendWhatsapp/SendSaveTheDateModal.vue';
import SendMasiveTicketsModal from '@/components/events/event/detail/sendEmail/SendMasiveTicketsModal.vue';
import SendGuestsExcelModal from '@/components/events/event/detail/sendEmail/SendGuestsExcelModal.vue';
import AssignTable from '@/components/events/event/detail/tables/AssignTableModal.vue';
import EventStatsCards from '@/components/events/dashboard/EventStatsCards.vue';
import ConfirmationSummaryChart from '@/components/events/dashboard/ConfirmationSummaryChart.vue';
import TableOccupationCard from '@/components/events/dashboard/TableOccupationCard.vue';
import NextScheduledDeliveryCard from '@/components/events/dashboard/NextScheduledDeliveryCard.vue';
import RecentActivityCard from '@/components/events/dashboard/RecentActivityCard.vue';
import DeliveryHistoryCard from '@/components/events/dashboard/DeliveryHistoryCard.vue';
import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle';
import ws from '@/services/events_guests';
import ws_event from '@/services/events';
import store from '@/store'

export default {
  name: 'Home',
  components: {
    GuestModal,
    ImportGuestsModal,
    SendMasiveInvitationModal,
    SendMasiveMessageModal,
    SendTableMessageModal,
    SendSaveTheDateModal,
    SendMasiveTicketsModal,
    SendGuestsExcelModal,
    AssignTable,
    EventModal,
    EventStatsCards,
    ConfirmationSummaryChart,
    TableOccupationCard,
    NextScheduledDeliveryCard,
    RecentActivityCard,
    DeliveryHistoryCard
  },
  data() {
    return {
      event_id: 0,
      dashboardRefreshToken: 0,
      metrics: {
        total: "0",
        assign: "0",
        confirm: "0",
        pending: "0",
        incomplete: "0",
        canceled: "0",
      },
      hasTables: 0,
      eventsOptions: [],
      eventSelect: 0,
      event: {
        code: "",
        name: "",
        date: "",
        address: "",
        status: {
          code: "",
          name: "",
        }
      }
    }
  },
  computed: {
    totalGuests() {
      return Number(this.metrics.total || 0)
    },
    showCommunicationsDropdown() {
      return this.showButton('schedule-sends') ||
        this.showButton('send-message') ||
        this.showButton('send-remember') ||
        this.showButton('send-invitation') ||
        this.showButton('send-save-date') ||
        this.showButton('send-preinvitation') ||
        this.showButton('send-event-reminder') ||
        this.showButton('send-tables') ||
        this.showButton('send-masive-tickets-email')
    },
    showCommunicationItemsDivider() {
      return this.showButton('send-message') ||
        this.showButton('send-remember') ||
        this.showButton('send-invitation') ||
        this.showButton('send-save-date') ||
        this.showButton('send-preinvitation') ||
        this.showButton('send-event-reminder') ||
        this.showButton('send-tables') ||
        this.showButton('send-masive-tickets-email')
    },
    showImportExportDropdown() {
      return this.showButton('import-guests') ||
        this.showButton('export-guests') ||
        this.showButton('send-excel-email') ||
        this.showButton('export-attendance') ||
        this.showButton('scanQR')
    }
  },
  mounted: async function () {
    this.loading();
    await this.setSelectEvent();
    await this.changeEvent();
    this.loaded();
  },
  methods: {
    showButton(type = "save", item = null) {
      if (!this.event || !this.event.status) return false

      switch (type) {
        case "download-pdf":
          return true;

        case "new-guest":
        case "import-guests":
          return this.event.status.code === "open";

        case "schedule-sends":
          return this.event.status.code === "open" && this.totalGuests > 0;

        case "assign-table":
        case "send-tables":
          return this.event.status.code === "open" &&
            this.hasTables > 0 &&
            this.totalGuests > 0;

        case "export-guests":
        case "send-excel-email":
        case "export-attendance":
          return this.totalGuests > 0;

        case "send-remember":
        case "send-invitation":
        case "send-save-date":
        case "send-preinvitation":
        case "send-event-reminder":
        case "send-message":
          return this.event.status.code === "open" && this.event.contact_method != "email";

        case "send-masive-tickets-email":
          return this.event.status.code === "open" && this.event.contact_method == "email" && this.totalGuests > 0;

        case "scanQR":
          return this.event.status.code === "open" &&
            this.event.external_registration_enabled;
        default:
          return false;
      }
    },
    async setSelectEvent(id = 0) {
      let response_events = await ws_event.getSimpleList();
      if (response_events.type == "success") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const availableEvents = response_events.data.filter((line) => {
          if (!line.date) {
            return true;
          }

          const eventDate = new Date(line.date + 'T00:00:00');
          return eventDate >= today;
        });

        this.eventsOptions = await this.$parseSelectOptionsOrdered(availableEvents, "id", "full_name", []);
        const hasSelectedEvent = id > 0 && availableEvents.some((line) => Number(line.id) === Number(id));

        if (hasSelectedEvent) {
          this.eventSelect = id;
        } else {
          if (availableEvents.length > 0) {
            this.eventSelect = availableEvents[0].id;
          } else {
            window.location.href = "/#/events"; return;
          }
        }
      }
    },
    async downloadExcel() {
      this.loading();

      let filters = this.getFilters();
      await ws.downloadExcel(filters);

      this.loaded();
    },
    async downloadPdf() {
      this.loading();

      await ws_event.downloadPdf({ id: this.eventSelect });

      this.loaded();
    },
    async updateModal() {
      this.$refs.addModal.updateModal(this.event);
    },
    async updateProcess(data) {
      this.loading();
      let response = await ws_event.update(data);

      if (response.type == "success") {
        await this.setSelectEvent(this.eventSelect);
        await this.changeEvent();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    getFilters() {
      let filters = {
        event_id: this.eventSelect,
        is_confirm: "",
        event_table_id: "",
      };

      return filters;
    },
    addGuestModal() {
      this.$refs.addGuestModal.storeModal(this.eventSelect);
    },
    importModal() {
      this.$refs.importModal.importExcelModal(this.eventSelect);
    },
    assignTable() {
      this.$refs.assignTableModal.showAssignModal(this.eventSelect);
    },
    sendMasiveInvitation() {
      this.$refs.sendMasiveInvitationModal.showSendModal(this.eventSelect, this.event);
    },
    sendMasiveFirstInvitation() {
      this.$refs.sendMasiveInvitationModal.showSendModal(this.eventSelect, this.event, 'invitation');
    },
    sendMasiveMessage() {
      this.$refs.sendMasiveMessageModal.showSendModal(this.eventSelect, this.event);
    },
    sendTableMessage() {
      this.$refs.sendTableMessageModal.showSendModal(this.eventSelect, this.event);
    },
    sendSaveTheDateMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.eventSelect, this.event);
    },
    sendPreInvitationMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.eventSelect, this.event, 'preinvitation');
    },
    sendEventReminderMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.eventSelect, this.event, 'event_reminder');
    },
    sendMasiveTickets() {
      this.$refs.sendMasiveTicketsModal.showSendModal(this.eventSelect, this.event);
    },
    sendGuestsExcelByEmail() {
      this.$refs.sendGuestsExcelModal.showSendModal(this.event, this.getFilters());
    },
    async downloadExcelAttendance() {
      this.loading();
      await ws.downloadExcelAttendance(this.getFilters());
      this.loaded();
    },
    goToEventDetail(tab = 'guests') {
      const query = tab && tab !== 'guests' ? { tab } : {};
      this.$router.push({
        name: 'event-detail',
        params: { id: this.event.id || this.eventSelect },
        query
      });
    },
    async getEvent() {
      let response_event = await ws_event.show(this.eventSelect);
      if (response_event.type == "success") {
        this.event = response_event.data;
      }
    },
    async getMetrics() {
      const bundle = await dashboardBundleService.get(this.eventSelect, { force: true });
      this.metrics = bundle.metrics || {
        total: "0",
        assign: "0",
        confirm: "0",
        pending: "0",
        incomplete: "0",
        canceled: "0",
      };
      this.hasTables = (bundle.tables || []).length;
    },
    refreshDashboardPanels() {
      dashboardBundleService.invalidate(this.eventSelect);
      this.dashboardRefreshToken += 1;
    },
    async changeEvent() {
      this.loading();

      if (!this.eventSelect) {
        this.loaded();
        return;
      }
      await Promise.all([
        this.getEvent(),
        this.getMetrics()
      ]);
      this.dashboardRefreshToken += 1;
      this.loaded();
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>
<style>
.totals__item {
  text-align: center;
  margin: 1em 1em 2em;
  padding: 20px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.11);
}

.totals__amount {
  font-size: 1.5rem;
  color: #2f353b;
  font-weight: bold;
  border-bottom: 2px solid #5C9BD1;
}

.totals__info {
  font-size: 1.1rem;
  color: #AAB5BC;
  font-weight: 600;
  text-transform: uppercase;
}

.totals__amount--with-taxes {
  border-top: 2px solid #5C9BD1;
}

.crema {
  background-color: #F4F0E5;
  color: #000;
}

.purple {
  background-color: #8E44AD;
  color: #fff;
}

.dark-purple {
  color: #703688;
}

.event-title {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.home-edit-button {
  margin-left: 6px;
}

.home-actions-wrap {
  display: flex;
  justify-content: flex-end;
}

.home-actions-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}

.home-actions-group,
.home-actions-group-secondary {
  display: inline-flex;
  align-items: center;
}

.home-actions-dropdown {
  display: inline-flex;
}

.home-actions-dropdown .btn {
  color: #fff;
}

@media (max-width: 767px) {

  /* Más aire entre datos del evento y selector */
  .card-header-actions+.card-header-actions {
    margin-top: 12px;
  }

  /* Espacio interno del bloque del selector */
  .card-header-actions .form-group {
    margin-bottom: 10px;
  }

  /* Botón editar más respirable */
  .home-edit-button {
    margin-left: 0;
    margin-bottom: 6px;
  }

  /* Botones de acción bien ordenados */
  .home-actions-wrap {
    justify-content: stretch;
  }

  .home-actions-toolbar {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .home-actions-group,
  .home-actions-group-secondary {
    width: 100%;
    margin-left: 0 !important;
    display: flex;
    flex-direction: column;
  }

  .home-actions-group .btn,
  .home-actions-group-secondary .btn,
  .home-actions-dropdown,
  .home-actions-dropdown .btn {
    width: 100%;
  }

  .home-actions-group .btn,
  .home-actions-group-secondary .btn,
  .home-actions-dropdown {
    margin-bottom: 8px;
  }

  /* Totals */
  .totals__list {
    flex-direction: column;
    align-items: center;
  }

  .totals__item {
    width: 100% !important;
    max-width: 280px;
    margin: 0.5rem 0 1rem;
  }

}
</style>